export default __webpack_public_path__ + "static/media/57_desktop.68228fa9.jpg";